// @ts-check
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import SystemSettings from '../Settings';
import { LBButton } from '@linearb/buzz';

const RepositorySetting = ({
  pickedRepoName,
  toggleSettings,
  repoSettings,
  pickedRepoId,
  toggleModal,
  apiTokens,
  setApiTokens
}) => {
  return (
    <Flex direction='column'>
      <Flex justify='space-between'>
        <Text size='x-x-large' pb='1rem' weight='bold'>
          {pickedRepoName} settings
        </Text>
        <LBButton variant='ghost' onClick={() => toggleSettings()}>
          Back to Repository list
        </LBButton>
      </Flex>
      <SystemSettings
        settings={repoSettings}
        entityId={pickedRepoId}
        entityType='repository'
        toggleModal={toggleModal}
        apiTokens={apiTokens}
        setApiTokens={setApiTokens}
      />
    </Flex>
  );
};

export default RepositorySetting;
